/* RESPONSIBLE TEAM: team-ai-insights */
import Helper from '@ember/component/helper';
import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';

const IconMap: Record<string, InterfaceIconName> = {
  'unknown-industry': 'globe',
  'software-technology': 'multiplatform',
  'gaming-gambling': 'click-element',
  ecommerce: 'shopping-cart',
  'financial-services': 'cash',
};

export default class LookupIndustryIcon extends Helper<{
  Args: {
    Positional: [string];
  };
  Return: InterfaceIconName;
}> {
  compute([industryValue]: [string]) {
    return IconMap[industryValue] || 'globe';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'lookup-industry-icon': typeof LookupIndustryIcon;
  }
}
